﻿import type { RedirectRequest, SilentRequest } from '@azure/msal-browser'
import * as msal from '@azure/msal-browser'
import { LogLevel } from '@azure/msal-browser'
import router from '@/router'

// Map old domains to new domains for MSAL redirect URI
export function getEffectiveOrigin(): string {
    const currentHost = window.location.hostname
    const domainMap: Record<string, string> = {
        'events.dn.dk': 'arrangementer.dn.dk',
        'events.affaldsindsamlingen.dk': 'mineindsamlinger.affaldsindsamlingen.dk'
    }
    
    // If current host is an old domain, use the new domain for MSAL redirect
    if (domainMap[currentHost]) {
        const protocol = window.location.protocol || 'https:'
        return `${protocol}//${domainMap[currentHost]}`
    }
    
    // Otherwise use the current origin
    return window.location.origin
}

const effectiveOrigin = getEffectiveOrigin()
const redirectUri = (effectiveOrigin + import.meta.env.VITE_MSAL_REDIRECT_PATH) as string

const msalConfig: msal.Configuration = {
    auth: {
        clientId: import.meta.env.VITE_MSAL_CLIENT_ID as string,
        authority: import.meta.env.VITE_MSAL_AUTHORITY as string,
        knownAuthorities: [import.meta.env.VITE_MSAL_KNOWN_AUTHORITIES as string],
        redirectUri: redirectUri,
        postLogoutRedirectUri: effectiveOrigin,
        navigateToLoginRequestUrl: false,

    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii) {
                    return
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message)
                        return
                    case LogLevel.Warning:
                        console.warn(message)
                        return
                }
            },
            piiLoggingEnabled: false
        },
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0,
        asyncPopups: false
    }
}
const msalInstance = new msal.PublicClientApplication(msalConfig)

const loginRequest: RedirectRequest = {
    scopes: ['openid', import.meta.env.VITE_MSAL_SCOPE as string]
}

const tokenRequest: RedirectRequest | SilentRequest = {
    scopes: [import.meta.env.VITE_MSAL_SCOPE as string],
    forceRefresh: false
}


// Global singleton for the redirect promise to ensure it's only called once
// even if the script is loaded/executed multiple times.
export function handleRedirectPromiseCached(): Promise<any> {
    if (!(window as any).__MSAL_REDIRECT_PROMISE__) {
        (window as any).__MSAL_REDIRECT_PROMISE__ = msalInstance.handleRedirectPromise();
    }
    return (window as any).__MSAL_REDIRECT_PROMISE__;
}

// Start processing immediately but silently
handleRedirectPromiseCached().then((response) => {
    if (response && response.account) {
        msalInstance.setActiveAccount(response.account);
    }
}).catch(() => { /* handled in store */ });

export { loginRequest, msalInstance, tokenRequest }
